<div class="tracker-dialog">
  <!-- Header with Close Button -->
  <div class="tracker-header">
    <div class="tracker-title-section">
      <svg>
        <use href="assets/icons.svg#graph"></use>
      </svg>
      <h2 class="tracker-title">Sales Opportunities Tracker</h2>
      <button class="btn refresh-btn" type="button">
        <svg>
          <use href="assets/icons.svg#refresh"></use>
        </svg>
      </button>
    </div>
    <button class="close-btn" type="button" (click)="closeDialog()">
      <svg>
        <use href="assets/icons.svg#cross"></use>
      </svg>
    </button>
  </div>

  <!-- Statistics Cards -->
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-number stat-open">{{ stats.open }}</div>
      <div class="stat-label">Open</div>
    </div>
    <div class="stat-card">
      <div class="stat-number stat-qualified">{{ stats.qualified }}</div>
      <div class="stat-label">Qualified</div>
    </div>
    <div class="stat-card">
      <div class="stat-number stat-won">{{ stats.won }}</div>
      <div class="stat-label">Won</div>
    </div>
    <div class="stat-card">
      <div class="stat-number stat-total">{{ stats.totalValue }}</div>
      <div class="stat-label">Total Value</div>
    </div>
  </div>

  <!-- Filter Tabs -->
  <div class="filter-tabs">
    <button
      class="filter-tab"
      [class.active]="selectedFilter === 'all'"
      (click)="filterOpportunities('all')"
    >
      All ({{ getOpportunityCount('all') }})
    </button>
    <button
      class="filter-tab"
      [class.active]="selectedFilter === 'open'"
      (click)="filterOpportunities('open')"
    >
      Open ({{ getOpportunityCount('open') }})
    </button>
    <button
      class="filter-tab"
      [class.active]="selectedFilter === 'qualified'"
      (click)="filterOpportunities('qualified')"
    >
      Qualified ({{ getOpportunityCount('qualified') }})
    </button>
    <button
      class="filter-tab"
      [class.active]="selectedFilter === 'won'"
      (click)="filterOpportunities('won')"
    >
      Won ({{ getOpportunityCount('won') }})
    </button>
    <button
      class="filter-tab"
      [class.active]="selectedFilter === 'lost'"
      (click)="filterOpportunities('lost')"
    >
      Lost ({{ getOpportunityCount('lost') }})
    </button>
  </div>

  <!-- Opportunities List -->
  <div class="opportunities-list">
    @if (filteredOpportunities.length === 0) {
      <p class="opportunities-empty">No {{ selectedFilter }} opportunites.</p>
    }
    @for (opportunity of filteredOpportunities; track opportunity) {
      <div class="opportunity-card">
        <div class="opportunity-main">
          <div class="opportunity-header">
            <h4 class="opportunity-name">{{ opportunity.name }}</h4>
            <span [ngClass]="getStatusBadgeClass(opportunity.status)">
              <svg>
                @switch (opportunity.status) {
                  @case ('won') {
                    <use href="assets/icons.svg#checked"></use>
                  }
                  @case ('open') {
                    <use href="assets/icons.svg#clock"></use>
                  }
                  @case ('qualified') {
                    <use href="assets/icons.svg#rise"></use>
                  }
                }
              </svg>
              {{ opportunity.status }}
            </span>
          </div>
          <div class="opportunity-details">
            <p class="opportunity-address">{{ opportunity.address }}</p>
            <div class="detail-item">
              <span class="detail-label">Package:</span>
              <span class="detail-value">{{ opportunity.package }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Total Value:</span>
              <span class="detail-value">{{ opportunity.totalValue }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Speed:</span>
              <span class="detail-value">{{ opportunity.speed }}</span>
            </div>
            <p class="opportunity-dates">
              Created: {{ opportunity.created }} • Updated: {{ opportunity.updated }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
